import React from 'react';
import images from '@assets/images-base';

import dayjs, { Dayjs } from 'dayjs';
import { IconCalendar } from '@components/Icon';
import { FORMAT_DATE, FORMAT_MONTH_ATTENDANCE } from 'constants/constants';
import { DatePickerCustomWrapper, PreNextIconDate, ReStyleDatePicker, WrapperNextDate } from './datepickerCustomStyle';
import { CONST_OPERATOR_INVOICE } from 'constants/language';

interface IDatePickerCustom {
  onChangeMonth: (day: Dayjs | any) => void;
  month?: Dayjs;
  normalPicker?: boolean;
  isHasBtnChange?: boolean;
  isLoading?: boolean;
  allowClear?: boolean;
  placeholder?: string;
}
const DatePickerCustomAttendance = ({
  onChangeMonth,
  month,
  normalPicker,
  isHasBtnChange = true,
  allowClear = true,
  isLoading = false,
  placeholder = CONST_OPERATOR_INVOICE.PLACEHOLDER_CHOOSE_MONTH,
}: IDatePickerCustom) => {
  const currentPicker = !normalPicker ? 'month' : 'date';
  const currentChange = !normalPicker ? 'month' : 'day';
  const isInput = !isHasBtnChange;

  const cellRenderCalendarAttendance = (value: any) => {
    return <div className="ant-picker-cell-inner">{dayjs(value).format('MM')}月〆</div>;
  };
  return (
    <DatePickerCustomWrapper>
      {isHasBtnChange && month && (
        <WrapperNextDate
          onClick={isLoading ? () => {} : () => onChangeMonth(month?.add(-1, currentChange))}
          className={isLoading ? 'disable' : ''}
        >
          <PreNextIconDate src={images.companySite.preLeft} />
        </WrapperNextDate>
      )}
      <ReStyleDatePicker
        picker={currentPicker}
        value={month}
        allowClear={allowClear}
        onChange={onChangeMonth}
        format={!normalPicker ? FORMAT_MONTH_ATTENDANCE : FORMAT_DATE}
        suffixIcon={<IconCalendar date={Number(month?.format('MM') || 1)} />}
        isInput={isInput}
        cellRender={cellRenderCalendarAttendance}
        placeholder={placeholder}
        disabled={isLoading}
        onKeyDown={(e: any) => {
          if (!['Enter', 'Backspace'].includes(e.key)) {
            let newKey = e.key.replace(/[^0-9０-９]/g, '');
            if (newKey !== e.key) {
              e.preventDefault();
            }
          }
        }}
      />
      {isHasBtnChange && month && (
        <WrapperNextDate
          onClick={isLoading ? () => {} : () => onChangeMonth(month?.add(+1, currentChange))}
          className={isLoading ? 'disable' : ''}
        >
          <PreNextIconDate src={images.companySite.nextRight} />
        </WrapperNextDate>
      )}
    </DatePickerCustomWrapper>
  );
};
export default DatePickerCustomAttendance;
